<template>
	<div>
			<h3>{{title | capitalize	}}</h3>
			<hr/>
	</div>
</template>

<script>
export default {
	props:[
		"title"
	],
	 filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
}
</script>

<style>
hr{
	width:1100px;
	background-color: #8d140e;
	opacity:0.4;
	margin-bottom: 0!important;
}
@media only screen and (max-width:767px) {
	hr{
		width:100%;
	}
	
}
</style>